import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { goodsReceiptScreenRoles } from '../../../src/utils/config'
import jwt_decode from 'jwt-decode';
import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends Component {
  componentDidMount() {
    if (this.props.screensAccess.status === true) {
      const {
        grnReceipts,
        poCollaborationDashboard,
        deliverySchedule,
        manageRoleAndAccess
      } = this.props.screensAccess.data;
      var token = localStorage.authToken;
      var decoded = jwt_decode(token);

      // if (poManagementDashboard && poManagementDashboard?.screenAccess === true) {
      //   this.props.history.push(
      //     `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorderManagement`
      //   );
      if (deliverySchedule && deliverySchedule?.screenAccess === true && goodsReceiptScreenRoles.includes(decoded.collaborator_role_id)) {
        this.props.history.push(
          `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/goodsReceipt`
        );
      } else if (poCollaborationDashboard && poCollaborationDashboard?.screenAccess === true) {
        this.props.history.push(
          `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorderManagement`
        );
      } else if (deliverySchedule && deliverySchedule?.screenAccess === true) {
        this.props.history.push(
          `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/fgBatches`
        );
      } else if (grnReceipts && grnReceipts?.screenAccess === true) {
        this.props.history.push(
          `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/GRNReceipts`
        );
      } else if (manageRoleAndAccess && manageRoleAndAccess?.screenAccess === true) {
        this.props.history.push(
          `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/teamMembers`
        );
      }
    }
  }
  render() {
    return (
      <React.Fragment>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
          }}
        >
          <CircularProgress style={{ color: 'primary' }} thickness={7} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  screensAccess: state.pcmp.common.accessControl.screensAccess,
});

export default connect(mapStateToProps, {})(withRouter(Loading));
